import { ReactNode } from 'react';
import { ActivityFeed } from './ActivityFeed';

export const ActivityFeedClient = (): ReactNode => <ActivityFeed />;
